import { forwardRef } from "react";
import type { HTMLAttributes } from "react";
import {
  Card,
  CardHeader,
  CardContent,
  CardFooter,
} from "@/components/shared/ui/Card";

interface ProjectCardSkeletonProps extends HTMLAttributes<HTMLDivElement> {}

const ProjectCardSkeleton = forwardRef<
  HTMLDivElement,
  ProjectCardSkeletonProps
>(({ className = "", ...props }, ref) => {
  return (
    <Card
      ref={ref}
      variant="bordered"
      className={`animate-pulse ${className}`}
      {...props}
    >
      <CardHeader>
        <div className="flex items-start justify-between gap-3">
          <div className="flex items-start gap-3 flex-1">
            {/* Thumbnail skeleton */}
            <div className="w-12 h-12 bg-gray-300 flex-shrink-0"></div>

            {/* Name and tagline skeleton */}
            <div className="flex-1 space-y-2">
              <div className="h-5 bg-gray-300 rounded w-3/4"></div>
              <div className="h-3 bg-gray-200 rounded w-full"></div>
            </div>
          </div>

          {/* Badge skeleton */}
          <div className="w-16 h-6 bg-gray-300 flex-shrink-0"></div>
        </div>
      </CardHeader>

      <CardContent>
        <div className="space-y-3">
          {/* Label skeleton */}
          <div className="flex justify-between">
            <div className="h-3 bg-gray-200 rounded w-24"></div>
            <div className="h-3 bg-gray-300 rounded w-16"></div>
          </div>

          {/* Progress bar skeleton */}
          <div className="w-full bg-gray-200 h-2 border border-gray-300"></div>
        </div>
      </CardContent>

      <CardFooter>
        {/* Button skeleton */}
        <div className="w-full h-9 bg-gray-300 border-2 border-gray-400"></div>
      </CardFooter>
    </Card>
  );
});

ProjectCardSkeleton.displayName = "ProjectCardSkeleton";

export default ProjectCardSkeleton;
